import {all, call, put, take, takeEvery} from 'redux-saga/effects'
import {buffers, END, eventChannel} from 'redux-saga';

import {uploadFailure, uploadProgress, uploadSuccess} from '../actions/FileUploadAction';
import {NEW_PROJECT} from "../actions/ProjectAction";

import axios from 'axios';

export function* handleNewProjectSaga() {

    yield takeEvery(NEW_PROJECT, function* (action) {

        const newProject = action.newProject;

        yield all(newProject.projectFiles.map((file, index) => {

            return uploadFileSaga(file, newProject.projectId, newProject.s3Objects[index].uploadUrl);
        }));
    })
}

// Upload the specified file
export function* uploadFileSaga(file, projectId, signedUrl) {
    // const channel = yield call(createUploadFileChannel, file, projectId); //Amplify Storage
    const channel = yield call(createUploadFileChannel, file, signedUrl); //axios
    while (true) {
        const {progress = 0, err, success} = yield take(channel);
        if (err) {
            yield put(uploadFailure(file, err));
            return;
        }
        if (success) {
            yield put(uploadSuccess(file));
            return;
        }
        yield put(uploadProgress(file, progress));
    }
}

/**
 * Using axios
 * @param file the file to upload
 * @param signedUrl the presigned url
 * @returns {EventChannel<any>}
 */
function createUploadFileChannel(file, signedUrl) {
    return eventChannel(emitter => {

        const config = {
            onUploadProgress: function (progressEvent) {

                emitter({file: file, progress: (progressEvent.loaded / progressEvent.total) * 100})
            }
        };

        axios.put(signedUrl, file, config)
            .then(() => {

                emitter({file: file, progress: 100, success: true});
                emitter(END);
            })
            .catch(error => {

                console.log(error);
                emitter({err: new Error(error)});
                emitter(END);
            });

        return () => {

        }
    }, buffers.sliding(2));
}